import React from 'react';
import PropTypes from 'prop-types';

const N_BARS = 40;

class FormHistogram extends React.Component {
  static propTypes = {
    price_list: PropTypes.arrayOf(PropTypes.number),
    histogram_range: PropTypes.arrayOf(
      PropTypes.shape({
        percentage: PropTypes.number,
        value: PropTypes.number
      })
    ),
    max: PropTypes.number,
    from: PropTypes.number,
    to: PropTypes.number,
    maxHeight: PropTypes.number
  };

  static defaultProps = {
    price_list: [],
    histogram_range: [],
    max: 100,
    from: 0,
    to: 100,
    maxHeight: 60
  };

  _distancesCache = undefined;

  calculateDistances = histogramRange => {
    if (undefined === this._distancesCache) {
      this._distancesCache = [];
      let previous;
      histogramRange.forEach(item => {
        if (previous !== undefined) {
          this._distancesCache.push({
            lengthValue: item.value - previous.value,
            lengthPercentage: item.percentage - previous.percentage,
            startOuterValue: previous.value,
            startOuterPercentage: previous.percentage
          });
        }
        previous = item;
      });
    }
    return this._distancesCache;
  };

  distanceOfPrice = (distances, price) =>
    distances.find(
      distance => price <= distance.lengthValue + distance.startOuterValue
    );

  _nonLinearIndexOfPrice = (value, distances) => {
    const distance = this.distanceOfPrice(distances, value);

    if (distance) {
      const innerBars = parseInt(N_BARS * distance.lengthPercentage);
      const innerValue = value - distance.startOuterValue;
      const innerIndex = parseInt(
        innerValue * innerBars / distance.lengthValue
      );
      const innerOffset = parseInt(N_BARS * distance.startOuterPercentage);

      return innerIndex + innerOffset - 1;
    }

    return value;
  };

  render() {
    const maxHeight = this.props.maxHeight;
    const barsAbsolute = Array(N_BARS).fill(0);
    const distances = this.calculateDistances(this.props.histogram_range);

    this.props.price_list.forEach(price => {
      const index = this._nonLinearIndexOfPrice(price, distances);
      barsAbsolute[index]++;
    });

    const ceiling = Math.max(...barsAbsolute.filter(val => val >= 0));
    const output = [];
    const generalWidth = `${100 / N_BARS}%`;
    const heightUnit = ceiling === 0 ? 0 : maxHeight / ceiling;
    const leftKnobIndex = this._nonLinearIndexOfPrice(
      this.props.from,
      distances
    );
    const rightKnobIndex = this._nonLinearIndexOfPrice(
      this.props.to,
      distances
    );

    barsAbsolute.forEach((bar, index) => {
      const classes =
        index > leftKnobIndex && index <= rightKnobIndex
          ? 'form-histogram__bar form-histogram__bar--active'
          : 'form-histogram__bar';

      const divStyle = {
        height: heightUnit * bar,
        width: generalWidth
      };
      output.push(
        <div key={`index-${index}`} className={classes} style={divStyle} />
      );
    });

    const style = {
      height: `${maxHeight}px`
    };

    return (
      <div className="form-histogram" style={style}>
        {output}
      </div>
    );
  }
}

export default FormHistogram;
